var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#EAF2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 24C32 28.4183 28.4183 32 24 32M32 24C32 19.5817 28.4183 16 24 16M32 24H16M24 32C19.5817 32 16 28.4183 16 24M24 32C26.001 29.8093 27.1388 26.9664 27.2006 24C27.1388 21.0336 26.001 18.1907 24 16M24 32C21.999 29.8093 20.8623 26.9664 20.8006 24C20.8623 21.0336 21.999 18.1907 24 16M16 24C16 19.5817 19.5817 16 24 16M18 32C18 33.1046 17.1046 34 16 34C14.8954 34 14 33.1046 14 32C14 30.8954 14.8954 30 16 30C17.1046 30 18 30.8954 18 32ZM34 32C34 33.1046 33.1046 34 32 34C30.8954 34 30 33.1046 30 32C30 30.8954 30.8954 30 32 30C33.1046 30 34 30.8954 34 32ZM18 16C18 17.1046 17.1046 18 16 18C14.8954 18 14 17.1046 14 16C14 14.8954 14.8954 14 16 14C17.1046 14 18 14.8954 18 16ZM34 16C34 17.1046 33.1046 18 32 18C30.8954 18 30 17.1046 30 16C30 14.8954 30.8954 14 32 14C33.1046 14 34 14.8954 34 16Z",
    stroke: "#0F62FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.91a3fbb2b9004cdee56da1272408f122.svg";
export { ForwardRef as ReactComponent };